/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Callback_InvalidInputs */

const en_common_auth_callback_invalid = /** @type {(inputs: Common_Auth_Callback_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link is invalid or expired.`)
};

const zh_common_auth_callback_invalid = /** @type {(inputs: Common_Auth_Callback_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接无效或已过期。`)
};

/**
* | output |
* | --- |
* | "This link is invalid or expired." |
*
* @param {Common_Auth_Callback_InvalidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_callback_invalid = /** @type {((inputs?: Common_Auth_Callback_InvalidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Callback_InvalidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_callback_invalid(inputs)
	return zh_common_auth_callback_invalid(inputs)
});
export { common_auth_callback_invalid as "common.auth.callback.invalid" }